
import React, { Component } from 'react';
import { Modal, Form, Input, InputNumber, Select, Row, Col, Switch, DatePicker } from 'antd';
import moment from 'moment';
import http from '../../../axios/http';
import messager from '../../ui/messager';
//会员选择
import MemberSelect from '../../crm/member/MemberSelect';
//转成数字
import { fixedNumber } from '../../../util/util';
import validator from '../../../util/validator';

const fields = [{
    "text": "客户来源",
    "field": "customerSource",
    "select": true,
    rules: [
        { required: true, message: '客户来源不能为空!' },
    ]
}, {
    "text": "所属商户",
    "field": "memberCode",
    "member": true,
    rules: [
        { required: true, message: '所属商户不能为空!' },
    ]
}, {
    "text": "客户名称",
    "field": "customerName",
    rules: [
        { required: true, message: '客户名称不能为空!' },
    ]
}, {
    "text": "扣款类型",
    "field": "type",
    "select": true,
    rules: [
        { required: true, message: '扣款类型不能为空!' },
    ]
}, {
    "text": "车架号",
    "field": "vin",
    rules: [
        { required: true, message: '车架号不能为空!' },
        { max: 128, message: '车架号不能超过32个字符！' },
    ]
}, {
    "text": "车牌号",
    "field": "plateNo",
    rules: [
        validator.plateNo
    ]
}, {
    "text": "金额",
    "field": "commission",
    "number": true,
    rules: [
        { required: true, message: '金额不能为空!' },
    ]
}, {
    "text": "是否折扣",
    "field": "hasDiscount",
    radio: true,
}, {
    "text": "实际费用",
    "field": "actualComission",
    "disabled": true
}, {
    "text": "收款时间",
    "field": "collectionTime",
    "date": true,
}, {
    "text": "新车牌号",
    "field": "newPlateNo",
    rules: [
        validator.plateNo
    ]
}, {
    "text": "备注",
    "field": "remark",
    textarea: true
}];


class TradeDeductionEditForm extends Component {

    state = {
        customerSource: 1,
    }

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }

            values["hasDiscount"] = values["hasDiscount"] ? 1 : 0;
            // eslint-disable-next-line eqeqeq
            if (this.state.customerSource == 1) {
                values["customerName"] = this.state.memberName;
            }
            if (values["collectionTime"] != null) {
                values["collectionTime"] = values["collectionTime"].format("YYYY-MM-DD HH:mm:ss");
            }
            values["applicationId"] = this.props.editData.applicationId;
            http.post({
                url: '/tradeDeduction/saveTradeDeduction',
                data: values,
                success: (res) => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };


    createDom = (data) => {
        const { form, editData, dictArray } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            // eslint-disable-next-line eqeqeq
            if ((this.state.customerSource == 2 || this.state.customerSource == 3) && item.field === "memberCode") {
                continue;
            }
            // eslint-disable-next-line eqeqeq
            if (this.state.customerSource == 1 && item.field === "customerName") {
                continue;
            }
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {getFieldDecorator(item.field, {
                        rules: item.rules,
                        initialValue:
                            item.date ? (editData[item.field] == null || editData[item.field] === "" ? null : moment(editData[item.field]))
                                : editData[item.field] != null && item.select ? "" + editData[item.field] : editData[item.field],
                    })(
                        item.date ? <DatePicker format="YYYY-MM-DD HH:mm:ss" showTime={{ format: 'HH:mm:ss' }} style={{ width: '100%' }} />
                            : item.select ? <Select onSelect={this.selectChange.bind(this, item.field)}>{dictArray[item.field].map(d => <Select.Option key={d["code"]}>{d["text"]}</Select.Option>)}</Select>
                                : item.radio ? <Switch checkedChildren="是" unCheckedChildren="否" onChange={this.radioChange.bind(this, item.field)} />
                                    : item.number ? <InputNumber precision={2} min={0.00} style={{ width: '100%' }} onChange={this.inputNumberChange.bind(this, item.field)} />
                                        : item.member ? <MemberSelect onSelect={this.selectChange.bind(this, item.field)} />
                                            : item.textarea ? <Input.TextArea />
                                                : <Input disabled={item.disabled === true} />
                    )}
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };


    create2Col = (fields) => {
        let dom = this.createDom(fields);
        let result = [];
        for (let i = 0; i < dom.length; i++) {
            let item = <Col key={i} span={11} offset={i % 2 === 0 ? 0 : 2}>{dom[i]}</Col>;
            result.push(item);
        }
        return result;
    }

    selectChange = (field, value) => {
        if (field === "customerSource") {
            this.setState({ customerSource: value });
        } else if (field === "memberCode") {
            this.setState({ memberName: value.name })
        }
    }

    //swith选择改变时触发
    radioChange = (field, checked) => {
        if (field === "hasDiscount") {
            const { form } = this.props;
            let commission = form.getFieldValue("commission");
            let actualComission = commission;
            if (checked && commission != null) {
                let discount = this.props.discount;
                actualComission = fixedNumber(commission * discount, 2);
            }
            form.setFieldsValue({
                "actualComission": actualComission,
            });
        }
    }

    //数字输入框变化
    inputNumberChange = (field, value) => {
        if (field === "commission") {
            const { form } = this.props;
            let hasDiscount = form.getFieldValue("hasDiscount");
            let discount = this.props.discount;
            let actualComission = value;
            if (hasDiscount) {
                actualComission = fixedNumber(value * discount, 2);
            }
            form.setFieldsValue({
                "actualComission": actualComission,
            });
        }
    }

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                width={800}
                visible={visible}
                title="其他业务"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                    <Row>{this.create2Col(fields)}</Row>
                </Form>
            </Modal>
        );
    }
}

const TradeDeductionEdit = Form.create()(TradeDeductionEditForm);

export default TradeDeductionEdit;